export default "__VITE_ASSET__CtXIDdVT__"